// src/config/publicBaseUrl.js
//
// Base URL for links we hand to PATIENTS (e-sign, referral form). These get
// texted out and opened on a phone, so they must point at the environment that
// actually holds the token — a staging-issued token does not exist in prod, so
// a staging build texting a regxportal.com link sends the patient to a dead
// page on the live site.
//
// Comes from REACT_APP_PUBLIC_BASE_URL when set (staging -> the staging host),
// and falls back to the PRODUCTION domain when absent, so an unconfigured
// production build behaves exactly as before.
//
// Note this is the PUBLIC site origin, which is not the same thing as the
// Cloud Functions host in ./functionsBase.js — keep the two separate.
//
// Usage:
//   import { PUBLIC_BASE_URL } from "../config/publicBaseUrl";
//   const link = `${PUBLIC_BASE_URL}/esign/${token}`;
export const PUBLIC_BASE_URL = (
  process.env.REACT_APP_PUBLIC_BASE_URL || "https://regxportal.com"
).replace(/\/+$/, "");
